import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomMessageService } from '@app/shared/components/custom-message/custom-message.service';
import { LoggerService } from '@app/logger/logger.service';
import { StockEquipmentsService } from '@app/shared/services/entities/stockEquipments.service';
import { Observable, map, startWith } from 'rxjs';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
const log = new LoggerService('EQUIPMENTS FORM COMPONENT');

@Component({
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
],
  selector: 'app-inventoryEquipmentsChangeStatus-form',
  templateUrl: './inventoryEquipmentsChangeStatus-form.component.html',
  styleUrls: ['./inventoryEquipmentsChangeStatus-form.component.scss']
})
export class InventoryEquipmentsChangeStatusFormComponent implements OnInit {

  public formGroup: FormGroup;
  public activeContract = null;
  public record = null;
  public statusList = [];
  public filteredPrd: Observable<any[]>;


  constructor(
    public dialogRef: MatDialogRef<InventoryEquipmentsChangeStatusFormComponent>,
    private customMessageService: CustomMessageService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private inventoryEquipmentsService: StockEquipmentsService
  ) { }

  async ngOnInit() {
    
    this.activeContract = this.data.contract;
    this.record = this.data.record;
    this.statusList = this.data.status;

    this.formGroup = this.formBuilder.group({
      status: [this.record ? this.record.status : null, Validators.required],
    });


  }

  /**@description Funcion para actulizar equipmento */
  async update(){
    try{

      if(!this.formGroup.valid){
        await this.customMessageService.open({title: 'Cuidado', type: 'warning', message: 'Es necesario completar todos los campos.', dismissBtn: true})
        return;
      }
  
      let data = JSON.parse(JSON.stringify(this.record));
      log.debug('data', data);
      
      for (const key of Object.keys(this.formGroup.value)) {
        data[key] = this.formGroup.value[key];
      }
      
      data['operationType'] = 'single'
      log.debug(data)
      log.debug('formGroup', this.formGroup.value)
  
      log.debug('record', this.record);
      log.debug('data', data);

      this.customMessageService.open({title: 'Espere', type: 'success', message: 'Guardando equipmento', loading: true });
      let apiResponse = await this.inventoryEquipmentsService.update(data);
      this.customMessageService.close();
      if (apiResponse.state == 'success') {
        await this.customMessageService.open({title: '¡Hecho!', type: 'success', message: apiResponse['message'], duration: 2000 });
        this.dialogRef.close(apiResponse.data);
      }else{
        await this.customMessageService.open({title: 'Error', type: 'error', message: apiResponse['message'], dismissBtn: true });
      }

    }catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({title: 'Error', type: 'error', message: err, dismissBtn: true });
    }



  }



}
